/**
 * Single source of truth: Mängelbericht-Status und Workflow-Übergänge.
 * Keine Kopplung zum Serviceauftrag-Status (nur diese Konstanten teilen).
 */

/** @type {readonly string[]} */
export const MAENGEL_STATUS_VALUES = Object.freeze([
  "Offen",
  "In Arbeit",
  "Mängel behoben",
  "Bericht gesendet",
  "Archiviert",
]);

/** Erlaubte Übergänge (kanonischer effektiver Status → Ziele) */
export const MAENGEL_ALLOWED_TRANSITIONS_ENTRIES = Object.freeze([
  ["Offen", ["In Arbeit"]],
  ["In Arbeit", ["Mängel behoben", "Offen"]],
  ["Mängel behoben", ["Bericht gesendet", "In Arbeit"]],
  ["Bericht gesendet", ["Archiviert", "Mängel behoben"]],
  ["Archiviert", ["Bericht gesendet"]],
]);

export function buildMaengelTransitionsMap() {
  return new Map(MAENGEL_ALLOWED_TRANSITIONS_ENTRIES);
}

export const MAENGEL_STATUS_ALIAS_ENTRIES = Object.freeze([
  ["offen", "Offen"],
  ["in arbeit", "In Arbeit"],
  ["behoben", "Mängel behoben"],
  ["mangel behoben", "Mängel behoben"],
  ["mängel behoben", "Mängel behoben"],
  ["bericht gesendet", "Bericht gesendet"],
  ["gesendet", "Bericht gesendet"],
  ["bericht zurückgeschickt", "Bericht gesendet"],
  ["bericht zurück geschickt", "Bericht gesendet"],
  ["zurückgeschickt", "Bericht gesendet"],
  ["archiviert", "Archiviert"],
  ["archiv", "Archiviert"],
]);

/** Alias für bestehende Client-Imports (`MANGEL_STATUS_VALUES`) */
export const MANGEL_STATUS_VALUES = MAENGEL_STATUS_VALUES;
